import React, { useCallback, useEffect, useRef, useState } from 'react';
import { DMapProps, DTileLayerProps, DZoomLayerProps } from './constants';
import {
  MapContainer as LMapContainer,
  TileLayer,
  ZoomControl,
  Polyline,
  Marker,
  Popup,
  Tooltip,
  useMap,
} from 'react-leaflet';
import './index.module.css';
import useLeafletMarker from './hooks/useLeafletMarker';
import MarkerCluster from './components/markerCluster';
import { GeomanControl } from './components/geoman';
import ResponsivePopupMarker from './components/responsive-marker';
const UsingMap = ({ center }) => {
  const hasMounted = useRef(false);

  const map = useMap();
  useEffect(() => {
    if (!hasMounted.current) {
      map.setView(center, 13);
      console.log('centerfirsMount', center);
      hasMounted.current = true;
    } else if (center) {
      console.log('centerAfterFirstMount', center);
      map.setView(center, 18);
    }
  }, [center]);
  return null;
};
const MapContainer = (props) => {
  const { markers, setData } = useLeafletMarker(props.markers);

  useEffect(() => {
    setData(props.markers);
  }, [props.markers]);

  return (
    <LMapContainer
      style={props?.style || { height: '100%', minHeight: '100%', zIndex: 20 }}
      {...{ ...DMapProps, ...props?.mapProps }}
    >
      <UsingMap center={props?.mapProps?.center || DMapProps.center} />
      <TileLayer {...{ ...DTileLayerProps, ...props?.tileLayerProps }} />
      {!markers?.properties?.markerCluster ? (
        markers?.markers?.length > 0 &&
        markers.markers.map((m, key) => {
          if (markers.properties.responsivePopup) {
            return (
              <ResponsivePopupMarker
                key={key}
                position={m?.position}
                icon={m?.icon}
                content={m?.popup?.content}
                hasTip={m?.popup?.props?.hasTip}
                autoPanPadding={m?.popup?.props?.autoPanPadding}
                offset={m?.popup?.props?.offset}
              />
            );
          } else {
            return (
              <Marker key={key} {...m}>
                {m?.tooltip?.content && (
                  <Tooltip {...m?.tooltip?.props}>
                    {m?.tooltip?.content}
                  </Tooltip>
                )}
                {m?.popup?.content && (
                  <Popup className="" {...m?.popup?.props}>
                    {m?.popup?.content}
                  </Popup>
                )}
              </Marker>
            );
          }
        })
      ) : (
        <MarkerCluster>
          {markers?.markers?.length > 0 &&
            markers.markers.map((m, key) => {
              if (markers.properties.responsivePopup) {
                return (
                  <ResponsivePopupMarker
                    key={key}
                    position={m.position}
                    icon={m.icon}
                    content={m.popup.content}
                    hasTip={m.popup.props.hasTip}
                    autoPanPadding={m.popup.props.autoPanPadding}
                    offset={m.popup.props.offset}
                  />
                );
              } else {
                return (
                  <Marker key={key} {...m}>
                    {m?.tooltip?.content && (
                      <Tooltip {...m?.tooltip?.props}>
                        {m?.tooltip?.content}
                      </Tooltip>
                    )}
                    {m?.popup?.content && (
                      <Popup className="" {...m?.popup?.props}>
                        {m?.popup?.content}
                      </Popup>
                    )}
                  </Marker>
                );
              }
            })}
        </MarkerCluster>
      )}
      {props?.polylineProps &&
        props?.polylineProps?.map((e, i) => <Polyline key={i} {...e} />)}
      {props.geomanControl && (
        <GeomanControl
          position="bottomleft"
          oneBlock
          {...props.geomanControlProps}
        ></GeomanControl>
      )}
      {props.zoomControl && (
        <ZoomControl {...{ ...DZoomLayerProps, ...props?.zoomLayerProps }} />
      )}
    </LMapContainer>
  );
};

export default MapContainer;
